export { default as GDMFeedbackModalActions } from './GDMFeedbackModalActions';

export type {
  GDMFeedbackModalActionsComponent,
  GDMFeedbackModalActionsProps,
} from './GDMFeedbackModalActions.type';
